"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFrameBody = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const document_1 = require("next/document");
const PageFrameContext_1 = require("./pageFrameService/PageFrameContext");
const CoreScripts_1 = require("./pageFrameService/CoreScripts");
const HeadTags_1 = require("./pageFrameService/HeadTags");
const BodyScripts_1 = require("./pageFrameService/BodyScripts");
const RegLogin_1 = require("./pageFrameService/RegLogin");
const Topnav_1 = require("./pageFrameService/Topnav");
const Footer_1 = require("./pageFrameService/Footer");
const PageFrameBody = ({ beforeTopNav, children, className, components, CoreScriptsComponent, pageFrameData, preloadTags, }) => (react_1.default.createElement(PageFrameContext_1.PageFrameContext.Provider, { value: preloadTags ? { ...pageFrameData, preloadTags } : pageFrameData },
    react_1.default.createElement(document_1.Head, null, components.includes('headTags') && react_1.default.createElement(HeadTags_1.HeadTags, null)),
    react_1.default.createElement("body", { className: className },
        beforeTopNav,
        components.includes('topnav') && react_1.default.createElement(Topnav_1.Topnav, null),
        children,
        components.includes('footer') && react_1.default.createElement(Footer_1.Footer, null),
        components.includes('reg') && react_1.default.createElement(RegLogin_1.RegLogin, null),
        components.includes('bodyScripts') && react_1.default.createElement(BodyScripts_1.BodyScripts, null),
        react_1.default.createElement(CoreScriptsComponent, { components: components }))));
exports.PageFrameBody = PageFrameBody;
const pageFrameDataComponentPropType = prop_types_1.default.shape({
    json: prop_types_1.default.objectOf(prop_types_1.default.shape({
        type: prop_types_1.default.string,
        content: prop_types_1.default.string,
        props: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])),
    })),
});
exports.PageFrameBody.propTypes = {
    children: prop_types_1.default.node.isRequired,
    className: prop_types_1.default.string,
    components: prop_types_1.default.arrayOf(prop_types_1.default.string),
    pageFrameData: prop_types_1.default.shape({
        bodyScripts: pageFrameDataComponentPropType,
        footer: pageFrameDataComponentPropType,
        headTags: pageFrameDataComponentPropType,
        reg: pageFrameDataComponentPropType,
        topnav: pageFrameDataComponentPropType,
    }).isRequired,
    preloadTags: pageFrameDataComponentPropType,
    CoreScriptsComponent: prop_types_1.default.element,
    beforeTopNav: prop_types_1.default.element,
};
exports.PageFrameBody.defaultProps = {
    components: ['headTags', 'topnav', 'footer', 'bodyScripts', 'reg'],
    CoreScriptsComponent: CoreScripts_1.CoreScripts,
    beforeTopNav: null,
};
